import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'
import { Polygon } from 'components/polygon'
import { theme } from 'styles/theme'

import { CYRELA_FINANCIALS_URL } from '../documents'

import * as S from './styles'

const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

const Esg: FC = memo(() => (
  <S.Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.TitleRow>
          <S.PolygonWrapper aria-hidden>
            <Polygon type="TriangleRound" width={28} height={36} draw="fill" color={theme.colors['cashme-magenta']} />
          </S.PolygonWrapper>

          <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
            ESG
          </Text>
        </S.TitleRow>

        <S.Lead>
          <Text size="heading4" color="var(--colors-neutral-text-default)">
            ESG (Enrivonmental, Social &amp; Governance) corresponde às práticas ambientais, sociais e de governança da
            CashMe.
          </Text>
        </S.Lead>

        <S.Panel>
          <S.Pillar>
            <S.PillarHeader>
              <S.IconWrapper aria-hidden>
                <NextImage src={`${IMAGES_PATH}/esg/ambiental.svg`} alt="" width={24} height={24} />
              </S.IconWrapper>
              <Text size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
                Ambiental
              </Text>
            </S.PillarHeader>
            <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
              Promover iniciativas que protegem e geram impactos positivos no meio ambiente.
            </Text>
          </S.Pillar>

          <S.Pillar>
            <S.PillarHeader>
              <S.IconWrapper aria-hidden>
                <NextImage src={`${IMAGES_PATH}/esg/social.svg`} alt="" width={24} height={24} />
              </S.IconWrapper>
              <Text size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
                Social
              </Text>
            </S.PillarHeader>
            <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
              Engajamento na defesa de direitos e na redução de desigualdade na sociedade.
            </Text>
          </S.Pillar>

          <S.Pillar $wide>
            <S.PillarHeader>
              <S.IconWrapper aria-hidden>
                <NextImage src={`${IMAGES_PATH}/esg/governanca.svg`} alt="" width={24} height={24} />
              </S.IconWrapper>
              <Text size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
                Governança
              </Text>
            </S.PillarHeader>

            <S.PillarBody>
              <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
                Independência da alta administração, medidas contra a corrupção, a discriminação e o assédio.
              </Text>
              <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
                A CashMe é uma empresa do Grupo Cyrela, sendo este seu acionista majoritário, e é comandada pelo
                executivo Juliano Bello.
              </Text>
              <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
                Visando a transparência nas relações, visualize{' '}
                <S.Link href={CYRELA_FINANCIALS_URL} target="_blank" rel="noopener noreferrer">
                  aqui
                </S.Link>{' '}
                as informações financeiras, clicando na opção{' '}
                <S.Emphasis>Demonstrações Financeiras (ITR /DFP) e o período desejado.</S.Emphasis>
              </Text>
            </S.PillarBody>
          </S.Pillar>
        </S.Panel>
      </Col>
    </Grid>
  </S.Section>
))

Esg.displayName = 'Esg'

export default Esg
